import React, { useState, useEffect } from "react";
import { Tab, Tabs, Container, Row, Col, Card } from "react-bootstrap";
import ReportByNo_CustomerService from '../Components/CustomerServices/ReportByNo_CustomerService';
import UploadFileForReversal from '../Components/CustomerServices/UploadFileForReversal';
import CustomerService_Header from '../Components/CustomerServices/CustomerService_Header';
import UploadFileForReversalTXT from '../Components/CustomerServices/UploadFileForReversalTXT';
const Reversal = () => {
    const [userData, setUserData] = useState(null);

    // Load user data from sessionStorage on component mount
    useEffect(() => {
        const user = JSON.parse(sessionStorage.getItem("user"));
        if (user) {
            setUserData(user);
        } else {
            console.log("No user found in sessionStorage");
        }
    }, []);

    // Render content based on user role
    if (userData && userData.userRole === "CustomerService") {
        return (
            <div className="container-fluid">
                <CustomerService_Header />

                <Container className="mt-4">
                    <Tabs defaultActiveKey="ReportByNo_CustomerService" id="report-tabs" className="mb-3">
                        {/* Tab for Date Filter Report */}
                        <Tab eventKey="ReportByNo_CustomerService" title="Search by No">
                            <Row className="mt-3">
                                <Col>
                                    <Card className="shadow-lg">
                                        <Card.Header>
                                            <div className="row">
                                                <div className="col-md-8">
                                                    <h5>Search by Number</h5>
                                                </div>
                                            </div>
                                        </Card.Header>
                                        <Card.Body>
                                            <ReportByNo_CustomerService /> {/* Remove search query prop */}
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Tab>

                        {/* Tab for MSISDN Report */}
                        <Tab eventKey="UploadFileForReversal" title="Upload Excel File ">
                            <Row className="mt-1">
                                <Col>
                                    <Card className="shadow-lg">
                                        <Card.Header>
                                            <div className="row">
                                                <div className="col-md-8">
                                                    <h5>Upload Excel File for Reversal</h5>

                                                </div>
                                            </div>
                                        </Card.Header>
                                        <Card.Body>
                                            <UploadFileForReversal /> {/* Remove search query prop */}
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Tab>

                        {/* Tab for MSISDN Report */}
                        <Tab eventKey="UploadFileForReversalTXT" title=" Upload Txt File">
                            <Row className="mt-1">
                                <Col>
                                    <Card className="shadow-lg">
                                        <Card.Header>
                                            <div className="row">
                                                <div className="col-md-8">
                                                    <h5>Upload Txt File for Reversal</h5>

                                                </div>
                                            </div>
                                        </Card.Header>
                                        <Card.Body>
                                            <UploadFileForReversalTXT /> {/* Remove search query prop */}
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Tab>
                    </Tabs>
                </Container>
            </div>
        );
    } else{
        return <div className="text-center mt-5">You do not have permission to view this page.</div>;
    }
};

export default Reversal;
